import styled, { css } from 'styled-components';
import { i as isMobile } from '../theme/style-mixins/isMobile/isMobile-CGsYoba7.js';

const Suffix = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-40027066__sc-1r39ksv-0"
})(["font:", ";flex:0 0 auto;box-sizing:border-box;white-space:nowrap;display:flex;align-items:center;background:transparent;color:", ";/*! @noflip */ border-radius:", ";", " ", " padding-inline-end:", ";padding-block:", ";", ""], ({
  theme
}) => theme.font.text.base.default, ({
  theme
}) => theme.text.color.default, ({
  theme
}) => `0 ${theme.border.radius.medium} ${theme.border.radius.medium} 0`, ({
  $ignoreTextDirection
}) => !$ignoreTextDirection && css(["/*! @noflip */ [dir=\"rtl\"] &&{/*! @noflip */ border-radius:", ";}"], ({
  theme
}) => `${theme.border.radius.medium} 0 0 ${theme.border.radius.medium}`), ({
  $disabled
}) => $disabled && css(["cursor:not-allowed;outline:none;opacity:1;background-color:", ";color:", ";"], ({
  theme
}) => theme.input.backgroundColor.unavailable, ({
  theme
}) => theme.text.color.unavailable), ({
  theme
}) => theme.controls.paddingInline.large.default, ({
  theme
}) => theme.controls.paddingBlock.base.default, isMobile(css(["font:", ";padding-inline-end:", ";padding-block:", ";"], ({
  theme
}) => theme.font.text.base.mobile, ({
  theme
}) => theme.controls.paddingInline.large.mobile, ({
  theme
}) => theme.controls.paddingBlock.base.mobile)));

export { Suffix as S };
//# sourceMappingURL=Suffix-BBA1XaEh.js.map
